// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/navbar_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu {
  height: 48px;
  min-height: 48px;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flexContainer {
  display: flex;
  align-items: center;
  height: 100%;
}

.logoContainer {
  width: 78px;
  position: relative;
  left: 10px;
}

.gameLogo {
  width: 76px;
  height: 64px;
  position: absolute;
  top: -20px;
}

.gameLogo img {
  width: 100%;
}

.avatarContainer {
  display: flex;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  margin-left: 20px;
}

.avatar {
  border-left: 2px solid #cd853f;
  border-right: 2px solid #cd853f;
  width: 48px;
  background-color: rgba(0, 0, 0, 0.5);
  background-size: cover;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.userInfo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 8px;
  padding-right: 24px;
  font-family: 'Kim';
}

.userInfo span {
  font-size: 14px;
  font-weight: 300;
  max-width: 140px;
  overflow: hidden;
  /* text-overflow: ellipsis; */
  white-space: nowrap;
  color: #fff;
}

.userLevel {
  display: flex;
  background-color: #654321;
  margin-top: 4px;
  padding: 2px 4px;
}

.userLevel span {
  font-size: 10px;
  line-height: 8px;
  color: rgb(255, 170, 0);
}

.expand_btn {
  background-size: 100% 100%;
  width: 36px;
  height: 36px;
  margin: 0 8px;
  position: relative;
}

.expand_btn:hover {
  cursor: pointer;
}

.expand_btn:hover .dropdown-content {
  display: block;
}

.dropdown-content {
  display: none;
  position: absolute;
  top: 36px;
  right: 4px;
  background-color: #f9f9f9;
  border-radius: 6px;
  border: 1px solid #49d7d8;
  background-color: #253644;
  overflow: hidden;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content img {
  vertical-align: middle;
  padding-bottom: 3px;
}

.dropdown-content div {
  color: #fff;
  padding: 8px 12px;
  text-decoration: none;
  display: block;
  text-align: left;
}

.dropdown-content a:hover {
  background-color: #2e4556;
}

.dropdown-content a span {
  font-size: 14px;
}

.menuItems {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  gap: 4px;
  left: 50%;
  transform: translateX(-50%);
}

.menuItemContainer {
  width: 72px;
  height: 84px;
  position: relative;
}

.menuItemContainer img {
  width: 100%;
}

.menuItemContainer .lock-overlay {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 32px;
  height: 32px;
  pointer-events: none;
  filter: brightness(1.2);
}

.activeFlag {
  padding-top: 10px;
}

login-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.wallet-btn {
  border-radius: 8px;
  /* Rounded corners */
  color: #ffffff;
  margin: 10px 0;
  /* Vertical margin for spacing between buttons */
  cursor: pointer;
  /* Adjust width as needed */
  text-align: center;
  transition: all 0.3s ease;
  /* Smooth hover and active transition */
  font-family: Kim;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  background-color: #ffcc00;
  /* Golden color */
  border: 2px solid #ffaa00;
  /* Slightly darker border for depth */
  font-size: 16px;
  padding: 6px 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-right: 10px;
}


.wallet-btn:hover {
  background-color: #ffaa00;
  /* Slightly darker on hover */
  border-color: #ff9900;
  /* Darker border on hover */
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  /* Deeper shadow on hover */
}

.wallet-btn:active {
  transform: scale(0.95);
  /* Scale down on press */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  /* Less shadow on press */
}

.avatarContainerLink {
    text-decoration: none;
    color: inherit;
    height: 100%;
    display: flex;
    font-size: inherit;
}

.avatarContainerLink .userInfo span {
    font-size: 16px;
    font-weight: 300;
}

.avatarContainerLink .userLevel span {
    font-size: 10px;
    line-height: 8px;
}

.avatarContainerLink:hover .avatarContainer {
    opacity: 0.8;
    cursor: pointer;
}

.menuItemContainer.disabled {
    cursor: not-allowed;
    pointer-events: all;
}

.menuItemContainer.disabled:hover {
    transform: none;
}

.menuItemContainer.disabled .menuItem {
    filter: grayscale(100%);
}

.login-container {
    max-width: 400px;
    padding: 20px;
}

.login-header {
    font-size: 1.2em;
    margin-bottom: 20px;
    text-align: center;
}

.back-button {
    margin-top: 20px;
    padding: 8px 16px;
    background-color: #666;
    border: none;
    border-radius: 4px;
    color: white;
    cursor: pointer;
    width: 100%;
}

.back-button:hover {
    background-color: #777;
}`, "",{"version":3,"sources":["webpack://./src/components/navbar/navbar.style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,yDAA8C;EAC9C,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,WAAW;EACX,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,gDAAgD;EAChD,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;EACvC,gBAAgB;EAChB,iEAAiE;EACjE,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;AACpB;;;AAGA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".menu {\n  height: 48px;\n  min-height: 48px;\n  width: 100%;\n  background-image: url(\"@assets/navbar_bg.png\");\n  background-size: 100% 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flexContainer {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n.logoContainer {\n  width: 78px;\n  position: relative;\n  left: 10px;\n}\n\n.gameLogo {\n  width: 76px;\n  height: 64px;\n  position: absolute;\n  top: -20px;\n}\n\n.gameLogo img {\n  width: 100%;\n}\n\n.avatarContainer {\n  display: flex;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n  margin-left: 20px;\n}\n\n.avatar {\n  border-left: 2px solid #cd853f;\n  border-right: 2px solid #cd853f;\n  width: 48px;\n  background-color: rgba(0, 0, 0, 0.5);\n  background-size: cover;\n}\n\n.spinner-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.loading-spinner {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #3498db;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.userInfo {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 0 8px;\n  padding-right: 24px;\n  font-family: 'Kim';\n}\n\n.userInfo span {\n  font-size: 14px;\n  font-weight: 300;\n  max-width: 140px;\n  overflow: hidden;\n  /* text-overflow: ellipsis; */\n  white-space: nowrap;\n  color: #fff;\n}\n\n.userLevel {\n  display: flex;\n  background-color: #654321;\n  margin-top: 4px;\n  padding: 2px 4px;\n}\n\n.userLevel span {\n  font-size: 10px;\n  line-height: 8px;\n  color: rgb(255, 170, 0);\n}\n\n.expand_btn {\n  background-size: 100% 100%;\n  width: 36px;\n  height: 36px;\n  margin: 0 8px;\n  position: relative;\n}\n\n.expand_btn:hover {\n  cursor: pointer;\n}\n\n.expand_btn:hover .dropdown-content {\n  display: block;\n}\n\n.dropdown-content {\n  display: none;\n  position: absolute;\n  top: 36px;\n  right: 4px;\n  background-color: #f9f9f9;\n  border-radius: 6px;\n  border: 1px solid #49d7d8;\n  background-color: #253644;\n  overflow: hidden;\n  min-width: 160px;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n}\n\n.dropdown-content img {\n  vertical-align: middle;\n  padding-bottom: 3px;\n}\n\n.dropdown-content div {\n  color: #fff;\n  padding: 8px 12px;\n  text-decoration: none;\n  display: block;\n  text-align: left;\n}\n\n.dropdown-content a:hover {\n  background-color: #2e4556;\n}\n\n.dropdown-content a span {\n  font-size: 14px;\n}\n\n.menuItems {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  gap: 4px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.menuItemContainer {\n  width: 72px;\n  height: 84px;\n  position: relative;\n}\n\n.menuItemContainer img {\n  width: 100%;\n}\n\n.menuItemContainer .lock-overlay {\n  position: absolute;\n  top: 45%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 32px;\n  height: 32px;\n  pointer-events: none;\n  filter: brightness(1.2);\n}\n\n.activeFlag {\n  padding-top: 10px;\n}\n\nlogin-buttons {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.wallet-btn {\n  border-radius: 8px;\n  /* Rounded corners */\n  color: #ffffff;\n  margin: 10px 0;\n  /* Vertical margin for spacing between buttons */\n  cursor: pointer;\n  /* Adjust width as needed */\n  text-align: center;\n  transition: all 0.3s ease;\n  /* Smooth hover and active transition */\n  font-family: Kim;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  background-color: #ffcc00;\n  /* Golden color */\n  border: 2px solid #ffaa00;\n  /* Slightly darker border for depth */\n  font-size: 16px;\n  padding: 6px 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-right: 10px;\n}\n\n\n.wallet-btn:hover {\n  background-color: #ffaa00;\n  /* Slightly darker on hover */\n  border-color: #ff9900;\n  /* Darker border on hover */\n  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);\n  /* Deeper shadow on hover */\n}\n\n.wallet-btn:active {\n  transform: scale(0.95);\n  /* Scale down on press */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  /* Less shadow on press */\n}\n\n.avatarContainerLink {\n    text-decoration: none;\n    color: inherit;\n    height: 100%;\n    display: flex;\n    font-size: inherit;\n}\n\n.avatarContainerLink .userInfo span {\n    font-size: 16px;\n    font-weight: 300;\n}\n\n.avatarContainerLink .userLevel span {\n    font-size: 10px;\n    line-height: 8px;\n}\n\n.avatarContainerLink:hover .avatarContainer {\n    opacity: 0.8;\n    cursor: pointer;\n}\n\n.menuItemContainer.disabled {\n    cursor: not-allowed;\n    pointer-events: all;\n}\n\n.menuItemContainer.disabled:hover {\n    transform: none;\n}\n\n.menuItemContainer.disabled .menuItem {\n    filter: grayscale(100%);\n}\n\n.login-container {\n    max-width: 400px;\n    padding: 20px;\n}\n\n.login-header {\n    font-size: 1.2em;\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n.back-button {\n    margin-top: 20px;\n    padding: 8px 16px;\n    background-color: #666;\n    border: none;\n    border-radius: 4px;\n    color: white;\n    cursor: pointer;\n    width: 100%;\n}\n\n.back-button:hover {\n    background-color: #777;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
